document.addEventListener('click', function(event) {
  const thumb = event.target.closest('.sh-product-gallery__thumb');

  if (!thumb) return;

  const gallery = thumb.closest('.sh-product-gallery');
  if (!gallery) return;

  const mediaId = thumb.getAttribute('data-media-id');

  gallery.querySelectorAll('.sh-product-gallery__thumb').forEach(function(item) {
    item.classList.remove('is-active');
  });

  gallery.querySelectorAll('.sh-product-gallery__media').forEach(function(item) {
    item.classList.remove('is-active');
  });

  thumb.classList.add('is-active');

  const target = gallery.querySelector(
    '.sh-product-gallery__media[data-media-id="' + mediaId + '"]'
  );

  if (target) {
    target.classList.add('is-active');
  }
});


document.addEventListener('change', function(event) {
  const input = event.target;

  /* Only respond to our native Shopify variant radios */
  if (!input.matches('variant-radios input[type="radio"]')) return;

  const variantRadios = input.closest('variant-radios');
  if (!variantRadios) return;

  const json = variantRadios.querySelector('script[type="application/json"]');
  if (!json) return;

  let variants;

  try {
    variants = JSON.parse(json.textContent);
  } catch (e) {
    return;
  }

  /* Get currently selected Colour / Size / etc */
  const selectedOptions = Array.from(
    variantRadios.querySelectorAll('input[type="radio"]:checked')
  ).map(function(input) {
    return input.value;
  });

  /* Find the actual Shopify variant matching those selections */
  const selectedVariant = variants.find(function(variant) {
    return variant.options.every(function(option, index) {
      return option === selectedOptions[index];
    });
  });

  if (!selectedVariant || !selectedVariant.featured_media) return;

  const mediaId = String(selectedVariant.featured_media.id);

  /* Find corresponding thumbnail in our Sh! gallery */
  const thumb = document.querySelector(
    '.sh-product-gallery__thumb[data-media-id="' + mediaId + '"]'
  );

  if (thumb) {
    thumb.click();
  }
});